__turbopack_context__.v({
  "icon": "GeoLocationButton-module-scss-module__qWxt6G__icon",
  "loadingSpinner": "GeoLocationButton-module-scss-module__qWxt6G__loadingSpinner",
  "useLocationButton": "GeoLocationButton-module-scss-module__qWxt6G__useLocationButton",
});
